import { z } from "zod";
/** Tipos de solicitação genérica ao RH (FASE-06-T39). */
export const meRequestKinds = ["DECLARATION", "DATA_CORRECTION", "QUESTION"];
export const createMeRequestSchema = z.object({
    kind: z.enum(meRequestKinds),
    subject: z.string().trim().min(3).max(120),
    body: z.string().trim().min(3).max(4000),
    attachmentObjectIds: z.array(z.string().uuid()).max(10).optional(),
});
export const meRequestMessageSchema = z.object({
    body: z.string().trim().min(1).max(4000),
    attachmentObjectIds: z.array(z.string().uuid()).max(10).optional(),
});
//# sourceMappingURL=me-request.js.map